module.exports = __webpack_public_path__ + "media/images/user_icon-6d6a03e5e78c4a0c7905f36ceb7f2a88.png";